export namespace Constants {

    export enum ResultadoAccionEnum {
        ERROR,
        EXITO,        
    }
}


// WEBPACK FOOTER //
// ./src/modules/zutils/constants.ts